import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'SidebarItem',
  props: {
  name: String,
  icon: String,
  iconClass: String,
  persistentIcon: Boolean,
  count: Number,
  countDanger: Boolean,
  isExpanded: Boolean,
  isDisabled: Boolean,
  isActive: Boolean,
  isMobileOnly: Boolean,
  isMobile: Boolean,
  onClick: Function,
  loaded: Boolean,
  hidden: Boolean,
},
  setup(__props) {



return { __sfc: true, }
}

})